import { GeoPoint, GQL_ID, Shop } from '@@types'
import { gql, QueryHookOptions, useQuery } from '@apollo/client'

type ShopWithProductInStock = {
  shop_id: GQL_ID
  amount: number
  shop: Pick<Shop, 'id' | 'name' | 'address' | 'shopGeoPoint' | 'isPickupDeliveryAvailable' | 'firstAvailableSlot' | 'open_time' | 'close_time' | 'distance'>
}

type ShopsWithProductInStockQuery = {
  shopsWithProductInStock: ShopWithProductInStock[]
}

type ShopsWithProductInStockVariables = {
  product_id: GQL_ID
  customerPosition?: GeoPoint
}

export const GQL_QUERY_SHOPS_WITH_PRODUCT_IN_STOCK = gql`
  query ShopsWithProductInStock (
    $product_id: ID!
    $customerPosition: GeoPointInput
  ) {
    shopsWithProductInStock (
      product_id: $product_id
      customerPosition: $customerPosition
    ) {
      shop_id
      amount
      shop {
        id
        name
        address
        open_time
        close_time
        distance
        shopGeoPoint {
          latitude
          longitude
        }
        isPickupDeliveryAvailable
      }
    }
  }
`

type useFetchShopsWithProductInStockProps = QueryHookOptions<ShopsWithProductInStockQuery, ShopsWithProductInStockVariables> & {
  productId: GQL_ID
  customerPosition?: GeoPoint
}

export const useFetchShopsWithProductInStock = ({
  productId,
  customerPosition,
  ...props
}: useFetchShopsWithProductInStockProps) => {

  const { data, loading, error, ...rest } = useQuery<ShopsWithProductInStockQuery, ShopsWithProductInStockVariables>(
    GQL_QUERY_SHOPS_WITH_PRODUCT_IN_STOCK,
    {
      ...props,
      variables: {
        product_id: productId,
        customerPosition
      }
    }
  )

  const shops = data?.shopsWithProductInStock ?? []

  return { data, loading, error, shops, ...rest }
}
